import React from 'react'
import Blogtimg01 from '../../../assets/images/blog1.png';
import Blogtimg02 from '../../../assets/images/blog2.png';
import Blogtimg03 from '../../../assets/images/blog3.png';
import { Link } from 'react-router-dom';

const Blog3data = [
    {
        name: "By Elei",
        date: "On 18 Feb 2024",
        Image: Blogtimg01,
        Index: "/Blogdetails",
        heading: "7 Essential Personal Finance Tips for NRIs You Need to Know",
        about: "Managing personal finances can be complex, especially for Non-Resident Indians (NRIs) who must navigate the financial systems of their country of residence and India. Proper financial planning ensures that NRIs can maximize their earnings, save efficiently, and invest wisely. Here are seven essential personal finance tips that every NRI should know. 1. Taxation As an […]"
    },
    {
        name: "By Deni",
        date: "On 18 Feb 2024",
        Image: Blogtimg02,
        Index: "/Blogdetails2",
        heading: "10 Things Every NRI Should Know About OCI Card",
        about: "For Non-Resident Indians (NRIs) and Persons of Indian Origin (PIO), the Overseas Citizen of India (OCI) card offers several advantages and privileges. Understanding the benefits, application process, and limitations of the OCI card can help streamline your connection with India. Here are 10 essential things every NRI should know about the OCI card:  What is […]"
    },
    {
        name: "By Jhon",
        date: "On 18 Feb 2024",
        Image: Blogtimg03,
        Index: "/Blogdetails3",
        heading: "10 Ways NRIs Can Resolve Family Disputes From Afar",
        about: "Being a Non-Resident Indian (NRI) comes with its own set of challenges, especially when it comes to managing family disputes from a distance. Whether it’s disagreements over property, financial matters, or interpersonal conflicts, here are ten effective ways NRIs can navigate and resolve family disputes while being geographically distant. 1.    Open Communication Channels Maintaining open […]"
    },
]

const Blogthree = () => {
    return (
        <div className="blog-three">
            <div className="container">
                <div className="heading-box text-center">
                    {/* <span className="heading-subtitle wow fadeInUp animated animated">
                        🤝 BLOG
                    </span> */}
                    <h2 className="heading-title wow fadeInUp animated animated mt-0 pt-0 pb-4 mb-8">
                        Recent news &amp; blogs
                    </h2>
                </div>
                <div className="row blog gutter-y-30 .gutter-x-25" >
                    {Blog3data.map((data, index) =>
                        <div key={index}
                            className="col-lg-4 col-md-6">
                            <div className="blog-three-box">
                                {/* <div className="blog-three-box-meta">
                                    <p>
                                        <Link to="#">{data.name}</Link>{" "}
                                    </p>
                                    <p>
                                        <Link to="#">{data.date}</Link>
                                    </p>
                                </div> */}
                                <div className="blog-three-box-image">
                                    <img src={data.Image} alt="blog-image" style={{width: "424px", height: "560px" , objectFit: "cover"}} />
                                </div>
                                <div className="blog-three-box-details">
                                    <h5>
                                        <Link to={data.Index}>
                                            {data.heading}
                                        </Link>
                                    </h5>
                                    <p>
                                        {data.about}
                                    </p>
                                    <Link to={data.Index} className="btn-link">
                                        Read More <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    )
}
export default Blogthree;